import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "p-2",
  style: {"height":"211px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.decideSTTIconComponent), {
      "is-hal": _ctx.isHal,
      locale: _ctx.locale
    }, null, 8, ["is-hal", "locale"]))
  ]))
}